import { Nullable } from "src/utils/util.types";
import { FiUser as User } from "react-icons/fi";
import { useGetUserByIdQuery } from "src/features/users/services/user.Service";
import { Link } from "react-router-dom";

export type RedeemedUserInfoProps = {
  redeemedBy: Nullable<string>;
};

export const RedeemedUserInfo = ({ redeemedBy }: RedeemedUserInfoProps) => {
  const { data: user } = useGetUserByIdQuery(redeemedBy ?? "", {
    skip: !redeemedBy,
  });

  return (
    <>
      {user && (
        <div className="border-t pt-3">
          <h3 className="text-lg font-medium text-gray-900 mb-4">Redeemed By</h3>
          <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl shadow-lg border border-blue-200 p-6 transition-all duration-200 hover:shadow-xl hover:border-blue-400">
            <div className="flex items-center space-x-3">
              {user?.pictureURL ? (
                <img src={user.pictureURL} alt={user.name} className="w-10 h-10 rounded-full object-cover" />
              ) : (
                <svg
                  className="w-10 h-10 text-gray-400 bg-gray-200 rounded-full p-2"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                    clipRule="evenodd"
                  ></path>
                </svg>
              )}
              <div className="flex-1 min-w-0">
                <Link
                  to={`/users/${user?.id}`}
                  className="text-blue-600 hover:text-blue-800 font-medium text-sm truncate"
                >
                  {user?.name}
                </Link>
                <p className="text-sm text-gray-600 truncate">{user?.email}</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
